import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { ReplicateKey$ } from "../schemas/schemas_0";
export { $Command };
export class ReplicateKeyCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("TrentService", "ReplicateKey", {})
    .n("KMSClient", "ReplicateKeyCommand")
    .sc(ReplicateKey$)
    .build() {
}
